<template>
  <ContentSection indent="none">
    <Container :indent="spacing">
      <AppImage
        v-if="data.image_top"
        :asset="data.image_top"
        class="h-screen max-h-[40vh] object-cover md:-mb-[15%] md:w-3/4 lg:-mb-[10%] xl:-mb-[5%]"
      />
      <div v-if="data.text" class="z-10 flex min-h-[30vh] justify-end">
        <Bard
          :content="data.text"
          class="z-10 text-pretty bg-white py-10 text-base font-normal md:mr-[5%] md:w-3/4 md:p-24 md:py-16 lg:w-2/3"
        />
      </div>
      <div
        class="lg:-m5-[10%] z-0 flex w-full justify-end md:-mt-[15%] xl:-mt-[5%]"
      >
        <AppImage
          v-if="data.image_bottom"
          :asset="data.image_bottom"
          class="h-screen max-h-[40vh] object-cover md:w-3/4"
        />
      </div>
    </Container>
  </ContentSection>
</template>

<script lang="ts" setup>
import { type AssetFragment } from '#gql'

defineProps<{
  data: {
    image_top: AssetFragment
    image_bottom: AssetFragment
    text: string
  }
}>()

const { smaller } = useBreakpoints(tailwindBreakpoints)

const spacing = computed(() => {
  if (smaller('md').value) {
    return 'default'
  }
  return 'none'
})
</script>
